import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { checkUniqueHandle } from 'modules/org/actions'
import DealLinkSuccessStep from 'layouts/DealLinkSuccessStep'
import { getDefaultDirectoryUrl } from 'containers/OnboardingCompanyInfo'

const mapStateToProps = (state) => {
  return {
    defaultDirectoryUrl: getDefaultDirectoryUrl(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    checkUniqueHandle
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(DealLinkSuccessStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingWelcome/index.js